import * as profileEvents from "../../store/events/profile";
import Box from "@mui/material/Box";
import Button from "../../components/Button/Button";
import ErrorMessages from "../../components/ErrorMessages/ErrorMessages";
import FormSelect from "../../components/Form/FormSelect";
import FormTextField from "../../components/Form/FormTextField";
import React from "react";
import TaskHeader from "../../components/Task/TaskHeader";
import TaskTemplate from "../templates/TaskTemplate";
import { connect } from "react-redux";
import useNavigateQSA from "../../utils/hooks/useNavigateQSA";
import {
	Form,
	isArrayOfLength,
	isDefined,
	isObject,
	isStringOfLength
} from "@pheaa/channels-component-library";
import {
	HTML_ATTR_PATTERN_PHONE_DOMESTIC,
	HTML_ATTR_PATTERN_PHONE_INTERNATIONAL,
	SYSTEM_ERROR_MESSAGE_400,
	getErrorMessageForCode
} from "../../config/common";

const EditContactPhoneView = ({ title, ...props }) => {

	let primaryPhoneObj = null;

	const {
		contactsPhonesErrors,
		contactsPhonesIsLoading,
		countryCodes,
		getCountryCodes,
		isCountryCodesFailed,
		isCountryCodesPending,
		profileData,
		updateContactsPhones
	} = props;

	if (isObject(profileData) && isObject(profileData.contacts) && isArrayOfLength(profileData.contacts.phones)) {
		primaryPhoneObj = profileData.contacts.phones.find(phoneObj => phoneObj.id === "primary");
	}

	const [selectedCountryCode, setSelectedCountryCode] = React.useState("");
	const [selectedPhoneCode, setSelectedPhoneCode] = React.useState(primaryPhoneObj?.countryCode || "");
	const navigate = useNavigateQSA();

	const handleCountryCodeChange = e => {
		const { value } = e.target;
		const changeParts = value.split("::");
		setSelectedCountryCode(changeParts[0]);
		setSelectedPhoneCode(changeParts[1]);
	};

	const handleSubmit = (e, formData) => {
		updateContactsPhones([{
			extension: null,
			id: "primary",
			isValid: true,
			lineType: (primaryPhoneObj?.lineType || "mobile"),
			number: "",
			...formData,
			countryCode: (isStringOfLength(formData.countryCode) ? formData.countryCode.replace(/^\+/, "") : (primaryPhoneObj?.countryCode || ""))
		}], () => {
			navigate("/profile");
		});
	};

	React.useEffect(() => {

		if (!isArrayOfLength(countryCodes) && !isCountryCodesFailed && !isCountryCodesPending) {
			getCountryCodes();
		}
	}, [
		countryCodes,
		getCountryCodes,
		isCountryCodesFailed,
		isCountryCodesPending
	]);

	return (
		<TaskTemplate>
			<TaskHeader
				closeCallback={() => { profileEvents.clearErrors(); }}
				closeTaskDestination="/profile"
				title={title}
			/>
			<Form
				id="defaultFormNarrow"
				onSubmit={handleSubmit}
			>
				<Box mt={6}>
					<ErrorMessages
						errorMessages={contactsPhonesErrors.map(error => {
							return { ...error, message: getErrorMessageForCode(error.code, { 400: { message: SYSTEM_ERROR_MESSAGE_400 } }) };
						})}
					/>
					<Box mt={2.5}>
						<FormSelect
							label="Country or Region"
							onChange={handleCountryCodeChange}
							options={countryCodes.map(countryCode => ({
								label: countryCode.name,
								value: `${countryCode.countryCode}::${countryCode.phoneCode}`,
							}))}
							required={!isDefined(primaryPhoneObj?.countryCode)}
							value={isStringOfLength(selectedCountryCode) && isStringOfLength(selectedPhoneCode) ? `${selectedCountryCode}::${selectedPhoneCode}` : ""}
						/>
						<Box sx={{ position: "relative" }}>
							<Box
								component="input"
								name="countryCode"
								readOnly={true}
								sx={{
									all: "unset",
									color: "black",
									fontSize: "1.6rem",
									fontWeight: 400,
									height: "3.1rem",
									left: "1.3rem",
									lineHeight: "normal",
									top: "1.9rem",
									position: "absolute",
									width: `${(12 + (12 * selectedPhoneCode.length)) / 10}rem`,
									zIndex: "+1"
								}}
								value={`+${selectedPhoneCode}`}
							/>
							<FormTextField
								inputStyle={`cmp-form-text--animated-label cmp-form-text--isActive cmp-form-text--left-adornment-${selectedPhoneCode.length}`}
								name="number"
								pattern={selectedPhoneCode === "1" ? HTML_ATTR_PATTERN_PHONE_DOMESTIC : HTML_ATTR_PATTERN_PHONE_INTERNATIONAL}
								required={true}
								title="Phone Number"
								value={primaryPhoneObj?.number}
							/>
						</Box>
						<Box
							mb={1.75}
							mt={5.625}
						>
							<Button
								disabled={contactsPhonesIsLoading}
								processing={contactsPhonesIsLoading}
								type="submit"
								variant="contained"
							>
								Save
							</Button>
						</Box>
					</Box>
				</Box>
			</Form>
		</TaskTemplate>
	);
};

const mapStateToProps = state => ({
	contactsPhonesErrors: state.profile.contactsPhonesErrors,
	contactsPhonesIsLoading: state.profile.contactsPhonesIsLoading,
	countryCodes: state.profile.countryCodes,
	isCountryCodesFailed: state.profile.isCountryCodesFailed,
	isCountryCodesPending: state.profile.isCountryCodesPending,
	profileData: state.profile.data
});

const mapDispatchToProps = dispatch => ({
	getCountryCodes: data => dispatch(profileEvents.getCountryCodes(data)),
	updateContactsPhones: (data, onSuccess) => dispatch(profileEvents.updateContactsPhones(data, onSuccess))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditContactPhoneView);